<template>
	<div style="width : 100%; height : 100%;">
		<div class="home-wrapper">
			<div class="blue-shadow"></div>
			<div class="home-container">
				<h1 class="welcome-message">Bienvenido.</h1>
				<span class="signout" @click.stop="onSignout()"><img src="/assets/logout.png" /> Cerrar Sesión </span>
				<partner-list></partner-list>
			</div>
		</div>
	</div>
</template>

<script>
import PartnerList from './ui/PartnerList'
import { SIGNOUT } from '@/vuex/mutations'

export default {
	components : { PartnerList },
	methods : {
		onSignout() {
			this.$store.commit(SIGNOUT);
			this.$router.push("/login");
		}
	}
}
</script>

<style lang="scss">
	.home-wrapper {
		height : 100%;
		width : 100%;
		position : absolute;
		background : url('/assets/background.jpg');
		background-size : cover;
		background-repeat : no-repeat;
		background-position : center;

		.blue-shadow {
			width : 100%;
			height : 100%;
			position : absolute;
			z-index : 0;
			top : 0;
			left : 0;
			background : #169eba;
			opacity : 0.6;
		}

		.home-container {
			width : 100%;
			height : 100%;
			position : absolute;
			top : 0;
			left : 0; 
			z-index : 9;

			.welcome-message {
				color : white;
				text-align : center;
				margin-top : 45px;
				margin-bottom : 60px;
			}

			.signout {
				cursor : pointer;
				display : flex;
				align-items : center;
				position : absolute;
				left : 20px;
				top : 20px;
				font-size : 12px;
				color : white;
				img {
					margin-right : 10px;
					width : 20px;
					height : 20px;
					object-fit: contain;
				}
			}			
		}
	}
</style>